<div class="my-sandbox max-width-lg bg-img">
  <div *ngIf="!dataLoaded;else showMySandBox" class="flex items-center bg-img">
    <app-page-loader></app-page-loader>
  </div>
  <ng-template #showMySandBox>
    <div *ngIf="allSandboxesCount === 0; else showSandboxes">
      <div class="flex flex-col items-center ta-center">
        <div class="mat-headline-2 primary-fg mt-200 mb-24">{{ 'SANDBOX.EMPTY_AT_THE_MOMENT' | transloco }}</div>
        <div class="mat-subtitle-2 mb-48">{{ 'SANDBOX.CREATE_FIRST_SANDBOX' | transloco }}</div>
        <!-- <button class="accent" [routerLink]="['/', tenant, RouterSegments.CATALOGUE]">{{ 'SANDBOX.START_EXPLORING' | transloco }}</button> -->
      </div>
    </div>
    <ng-template #showSandboxes>
      <div class="flex flex-col items-center justify-start pt-50 pb-40">
        <div class="mat-headline-1 primary-fg">{{ 'SANDBOX.MY_SANDBOX' | transloco }}</div>
        <div class="flex flex-row justify-between items-center w-100-percent">
          <div class="flex flex-row flex-wrap w-1/3">
            <button class="btn-link mt-6" [ngClass]="{ 'active' : filters.size === 0 }" (click)="clearFilter()">
              {{ 'SANDBOX.ALL' | transloco }} ({{ allSandboxesCount }})
            </button>
            <button class="btn-link mt-6" [ngClass]="{ 'active' : filters.has(sandboxCount.key) }"
              *ngFor="let sandboxCount of lineOfBusinessToSandboxCountMap | keyvalue"
              (click)="selectFilter(sandboxCount.key)">
              <ng-container *ngIf="lineOfBusinessMap">
                {{ ((lineOfBusinessMap[sandboxCount.key]?.displayName || sandboxCount.key) | split)[0] }} ({{sandboxCount.value}})
              </ng-container>
            </button>
          </div>
          <!-- <button class="accent" [routerLink]="['/', tenant, RouterSegments.CATALOGUE]">{{ 'SANDBOX.START_EXPLORING' | transloco }}</button> -->
        </div>
        <div class="flex flex-row flex-wrap w-1/3 w-100-percent">
          <ng-container *ngIf="filteredSandboxes?.length > 4; else showNoCarouselSandbox">
            <app-carousel [items]="filteredSandboxes" [numDisplayedItems]="4" class="m-auto">
              <ng-template #itemTemplate let-sandbox>
                <app-sandbox-card class="flex w-100-percent mt-24" 
                                  [sandbox]="sandbox"></app-sandbox-card>
              </ng-template>
            </app-carousel>
          </ng-container>
          <ng-template #showNoCarouselSandbox>
            <app-sandbox-card *ngFor="let sandbox of filteredSandboxes"
                              class="mt-24"
                              [sandbox]="sandbox"></app-sandbox-card>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
<div class="mt-60 mb-50" *ngIf="dataLoaded">
  <app-our-services></app-our-services>
</div>
